import { css } from '@emotion/react';

export const tooltipContainerStyles = (fullWidth?: boolean) => css`
  position: relative;
  display: ${fullWidth ? 'block' : 'inline-block'};
  ${fullWidth &&
  `
    width: 100%;
    max-width: 100%;
  `}
`;

export const tooltipContentStyles = css`
  z-index: 1000;
  border: 1px solid var(--color-neutral-900);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-tooltip);
  background-color: var(--color-neutral-900);
  padding: var(--spacing-2) var(--spacing-3);
  max-width: 320px;
  color: var(--color-base-white);
  font-size: 14px;
  line-height: 20px;
  pointer-events: none;
  text-wrap: pretty;
`;
